import { render } from "./activity.vue?vue&type=template&id=6cbf7528&scoped=true&ts=true"
import script from "./activity.vue?vue&type=script&lang=ts"
export * from "./activity.vue?vue&type=script&lang=ts"

import "./activity.vue?vue&type=style&index=0&id=6cbf7528&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbf7528"]])

export default __exports__